import {Component, Input} from '@angular/core';
import {ReporteServices} from '../../services/reporte.services';

@Component({
  selector:"indicadores-widget",
  templateUrl:"../../templates/widgets/indicadores.widget.template.html"
})
export class IndicadoresWidgetComponent {

  public datosTabla:any[] = [];

  @Input()
  nombreParticipante:string = "Colaboradores";

  @Input()
  verPptoTotal:boolean = true;

  pptoTotal:number = 0;

  constructor(private rs: ReporteServices) {}

  consultar(entidad: number, idEntidad: any, fecha1: string, fecha2: string) {
    this.datosTabla = [];
    this.pptoTotal = 0;
    this.rs.devolverReporteIndicadores(entidad,idEntidad,fecha1,fecha2).subscribe(d=>{

      if(d.data.reporteIndicadores){

        let data = JSON.parse(d.data.reporteIndicadores);
        console.log(data);

        for(let d of data) {
          this.datosTabla.push(d);
          this.pptoTotal += d.meta;
        }
      }

      // console.log(`la meta total es de ${this.pptoTotal}`);
    })
  }

  consultandoDatos(){
    this.datosTabla = [];
    this.pptoTotal = 0;
  }

  ingresarDatos(reporteIndicadores:any){


      let data = JSON.parse(reporteIndicadores);


      for(let d of data) {
        this.datosTabla.push(d);
        this.pptoTotal += d.meta;
      }

  }


  semaforoIndGeneral(indicador: any, valor) {
    let clases = [];

    if(!this.rs.mostrarSemaforo)
      return clases;

    switch (indicador) {
      case 1:
        if (valor < this.rs.indicadores.ticketPromedio)
          clases.push('semRojo');
        break;
      case 2:
        if (valor < this.rs.indicadores.articuloTicket)
          clases.push('semRojo');
        break;
      case 3:
        if (valor < this.rs.indicadores.ticketDia)
          clases.push('semRojo');
        break;
      case 4:
        if (valor < this.rs.indicadores.ventaDia)
          clases.push('semRojo');
        break;
    }

    return clases;
  }


}
